module.exports = __webpack_public_path__ + "img/logo-econet-2.90a31d23.png";